import React from 'react';

import { styled } from 'core/styles';
import { MaybeEither, toEither } from 'utils/either';
import { Rating } from 'domain/types';
import { ratingColors } from 'domain/utils';

import { NextSvgIcon } from '../NextSvgIcon';
import letterA from './images/letterA.svg';
import letterB from './images/letterB.svg';
import letterC from './images/letterC.svg';
import letterD from './images/letterD.svg';
import letterE from './images/letterE.svg';

type RatingLetterIconProps = {
  rating: MaybeEither<Rating>;
};

const lettersRating = {
  0: letterA,
  1: letterB,
  2: letterC,
  3: letterD,
  4: letterE,
};

export function RatingLetterIcon({ rating }: RatingLetterIconProps) {
  return toEither(rating).fold(
    r => <NextSvgIcon image={lettersRating[r]} alt="" fontSize="inherit" />,
    () => <RatingLetterElement rating="N/A">-</RatingLetterElement>,
  );
}

const RatingLetterElement = styled('span', {
  shouldForwardProp: prop => prop !== 'rating',
})<{
  rating: Rating | 'N/A';
}>(({ rating }) => ({
  lineHeight: 1,
  color: ratingColors[rating],
}));
